<template>
  <div class="modal-bg" v-show="show" @click="hideModal">
    <div class="modal-container">
      <div class="modal-header">
        {{ title }}
      </div>
      <div class="modal-main">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <!-- <button @click="hideModal">取消</button> -->
        <button @click="submit" class="submit-btn">确认</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
  },
  methods: {
    hideModal() {
      this.$emit('hideModal')
    },

    submit() {
      this.$emit('submit')
    },
  }
}
</script>

<style>
.modal-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgb(15 23 42 / 60%);
  backdrop-filter: blur(8px);
  z-index: 9999;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.modal-container {
  background: rgb(255 255 255 / 95%);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  border: 1px solid rgb(255 255 255 / 30%);
  box-shadow:
    0 25px 50px rgb(0 0 0 / 15%),
    0 0 0 1px rgb(255 255 255 / 10%);
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 480px;
  max-width: 90vw;
  max-height: 80vh;
  animation: slideIn 0.3s ease-out;
  display: flex;
  flex-direction: column;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.modal-header {
  height: 64px;
  background: rgb(255 255 255 / 10%);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgb(255 255 255 / 20%);
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
  position: relative;
  flex-shrink: 0;
}

.modal-header::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgb(255 255 255 / 15%) 0%, rgb(255 255 255 / 5%) 100%);
  pointer-events: none;
}

.modal-main {
  padding: 32px 40px;
  background: rgb(255 255 255 / 90%);
  backdrop-filter: blur(10px);
  line-height: 1.6;
  color: #334155;
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgb(248 250 252 / 80%);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgb(226 232 240 / 50%);
  flex-shrink: 0;
}

.submit-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 16px;
  padding: 12px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 8px 25px rgb(102 126 234 / 30%),
    0 0 0 1px rgb(255 255 255 / 10%);
  position: relative;
  overflow: hidden;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow:
    0 12px 35px rgb(102 126 234 / 40%),
    0 0 0 1px rgb(255 255 255 / 20%);
}

.submit-btn:active {
  transform: translateY(0);
}

.submit-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgb(255 255 255 / 20%), transparent);
  transition: left 0.5s;
}

.submit-btn:hover::before {
  left: 100%;
}

/* 响应式设计 */
@media (width <= 750px) {
  .modal-container {
    min-width: auto;
    width: 90vw;
    margin: 20px;
    max-height: 75vh;
  }

  .modal-main {
    padding: 24px 20px;
  }

  .modal-footer {
    padding: 20px;
  }

  .modal-header {
    height: 56px;
    font-size: 16px;
  }
}

/* 处理超小屏幕 */
@media (max-width: 480px) {
  .modal-container {
    width: 95vw;
    margin: 10px;
    border-radius: 16px;
    max-height: 70vh;
  }

  .modal-main {
    padding: 20px 16px;
  }

  .modal-footer {
    padding: 16px;
  }

  .submit-btn {
    padding: 10px 24px;
    font-size: 14px;
    border-radius: 12px;
  }
}

/* 处理中等屏幕的宽度问题 */
@media (min-width: 751px) and (max-width: 1024px) {
  .modal-container {
    min-width: 400px;
    max-width: 80vw;
  }
}

/* 确保内容不会溢出 */
.modal-main::-webkit-scrollbar {
  width: 6px;
}

.modal-main::-webkit-scrollbar-track {
  background: rgb(241 245 249 / 50%);
  border-radius: 3px;
}

.modal-main::-webkit-scrollbar-thumb {
  background: rgb(148 163 184 / 50%);
  border-radius: 3px;
}

.modal-main::-webkit-scrollbar-thumb:hover {
  background: rgb(148 163 184 / 70%);
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue